import { RangeFilterValue } from '../Filter/RangeFilterValue';
import { Attribute } from '../Model/Attribute';
import { ObjectUtility } from './ObjectUtility';

export class RangeUtility {
    public static areAttributesWithinRange(attributes: Attribute[], range: RangeFilterValue): boolean {
        return RangeUtility.areValuesWithinRange((attributes.map(a => a.numericValue)), range);
    }

    public static areValuesWithinRange(values: number[], range: RangeFilterValue): boolean {
        const min = range.min;
        const max = range.max;
        const numericValues = ObjectUtility.unique(values);

        // Product must have at least one `numericValue` bigger than or equal to min
        if (undefined === numericValues.find(v => v >= min)) {
            return false;
        }

        // Product must have at least one `numericValue` smaller than or equal to max
        return undefined !== numericValues.find(v => v <= max);
    }
}
